import { useInfiniteQuery } from 'react-query';
import {
  type GetBettieBalanceTransactionsResponse,
  getBettieBalanceTransactions
} from '../../services/bettieBalancesService';

export function useGetBettieBalanceTransaction() {
  return useInfiniteQuery<GetBettieBalanceTransactionsResponse>(
    ['bettieBalanceTransactions'],
    ({ pageParam }) => getBettieBalanceTransactions({ pageParam }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage?.meta?.pagination?.currentPage < lastPage?.meta?.pagination?.totalPages) {
          return lastPage?.meta?.pagination?.currentPage + 1;
        }
        return undefined;
      },
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: true
    }
  );
}
